<template>
<div>
  <h2>Are you sure you want to delete the item {{item.customerId}}</h2>
</div>
</template>

<script>
export default {
  name: 'ConfirmDelete',
  props: ['item']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/ConfirmDelete.vue